var React = require('react');

function Loader (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"10","cy":"10","r":"8.5","fill":"none","stroke":"#333","strokeWidth":"3","strokeOpacity":".08","key":0}),React.createElement("path",{"d":"M10 1.5a8.5 8.5 0 018.5 8.5","fill":"none","stroke":"#333","strokeWidth":"3","strokeOpacity":".4","key":1})]);
}

Loader.defaultProps = {"width":"20","height":"20"};

module.exports = Loader;

Loader.default = Loader;
